import { ComponentType, createElement, ReactElement } from "react";

import { IPatternSegment } from "./IPatternSegment";
import { IRoute, RoutePattern, RouteProps } from "./IRoute";
import {
    extractParameters,
    parseRoutePattern,
    routePath,
} from "./RouteFunctions";

export class Route<
    TProps extends RouteProps = Record<string, never>,
> implements IRoute<TProps> {
    private readonly patternSegments: IPatternSegment[];

    constructor(
        pattern: RoutePattern,
        private readonly component: ComponentType<TProps>,
    ) {
        this.patternSegments = parseRoutePattern(pattern);
    }

    public match(path: string): ReactElement<TProps> | false {
        const props = this.extractParameters(path);
        return props && createElement(this.component, props);
    }

    public toString(
        parameters?: TProps,
        hashValues?: { [key: string]: any },
    ): string {
        return routePath(this.patternSegments, parameters, hashValues);
    }

    public extractParameters(pathWithHash: string): TProps | false {
        return extractParameters(this.patternSegments, pathWithHash);
    }
}
